(function () {
  'use strict';

  let angular = window.angular;

  EdgeAgentModalController.$inject = [
    '$scope',
    '$rootScope',
    '$timeout',
    'AppUtils',
    'Customer',
    'EdgeAgent',
    'EdgeDeviceService',
    'EdgeAgentService',
    'WizardHandler',
  ];

  angular.module('app').component('deviceEdgeAgentWizardModal', {
    template:'<div class="wizard-single-step" ng-class="{transparent: ctrl.loading}"><wizard on-finish="ctrl.applyChanges()" indicators-position="top"><wz-step wz-data="{step: \'agent\'}" wz-title="{{:: \'entities.edgeagent.modelName\' | translate}}" canexit="ctrl.validateGeneral"><div style="height: 500px"><device-edge-agent-form edge-agent="ctrl.edgeAgent" names="ctrl.names" template-tags="ctrl.templateTags" assets="ctrl.edgeAgent.assets"></device-edge-agent-form></div></wz-step><wz-step wz-data="{step: \'assets\'}" wz-title="{{:: \'entities.asset.modelNamePl\' | translate}}"><div style="height: 500px" ng-if="ctrl.currentStep.name === \'assets\'"><div class="form-group"><label translate>entities.project.modelNamePl</label><ui-select ng-model="ctrl.projectId" theme="select2" ng-change="ctrl.filterParents()"><ui-select-match placeholder="{{\'general._select.an\' | translate}} {{\'entities.project.modelName\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="project.id as project in ctrl.projects | filter: $select.search"><div>{{project.name}}</div></ui-select-choices></ui-select></div><div class="form-group"><label translate>entities.asset.modelNamePl</label><ui-tree-select ng-model="ctrl.selectedParent" ng-disabled="!ctrl.projectId" ng-change="ctrl.selectParent()" placeholder="{{::\'general._select.an\' | translate}} {{::\'entities.asset.modelName\' | translate}}" data="ctrl.filteredParents" label-field="\'name\'" parent-field="\'assetId\'"></ui-tree-select></div><div class="form-group clearfix"><multi-select-dropdown items="ctrl.filteredAssets" disabled="ctrl.loadingAssets" selected-items="ctrl.selectedAssets"></multi-select-dropdown></div><div class="clearfix"><button class="btn btn-default pull-right border-default" ng-click="ctrl.addAssets()" ng-disabled="!ctrl.selectedAssets.length || ctrl.loadingAssets"><i class="fas fa-fw" ng-class="ctrl.loadingAssets? \'fa-spinner fa-spin\': \'fa-plus\'"></i> <span translate>buttons.add</span></button></div><hr><edge-agent-asset-table agent-assets="ctrl.edgeAgent.assets" assets="ctrl.assets"></edge-agent-asset-table></div></wz-step><wz-step wz-data="{step: \'agent-content\'}" wz-title="{{:: \'entities.edgeagent.modelNamePl\' | translate}}" canexit="ctrl.validateContent"><div ng-if="ctrl.currentStep.name === \'agent-content\'"><div style="position: relative; height: 500px; overflow-y: auto; overflow-x: hidden"><edge-agent-json edge-agent="ctrl.edgeAgent" template-tags="ctrl.templateTags" device="ctrl.device"></edge-agent-json></div></div></wz-step><div ng-if="ctrl.saveError" class="alert alert-warning text-center marginB0">{{ctrl.saveError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" wz-previous ng-disabled="ctrl.currentStep.index === 0" translate>buttons.prevStep</button> <button class="btn btn-primary" autofocus wz-next>{{(ctrl.enabledSteps === ctrl.currentStep.index + 1 ? \'buttons.save\' : \'buttons.nextStep\') | translate}}</button></div></wizard></div><spinner css-class="\'small\'" show-logo="true" show="ctrl.loading"></spinner>',
    controller: EdgeAgentModalController,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function EdgeAgentModalController(
    $scope,
    $root,
    $timeout,
    utils,
    Customer,
    EdgeAgent,
    EdgeDeviceService,
    EdgeAgentService,
    WizardHandler
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.device = vm.resolve.device;
      vm.projects = vm.resolve.projects;
      vm.assets = vm.resolve.assets;
      vm.assetsArray = Object.values(vm.assets);
      vm.templateTags = [];

      if (vm.projects.length === 1) {
        vm.projectId = vm.projects[0].id;
        filterParents();
      }
      vm.edgeAgent = angular.copy(vm.resolve.edgeAgent || { enabled: false });
      vm.edgeAgentAssets = angular.copy(vm.edgeAgent.assets || []);
      vm.names = vm.resolve.names;

      /*$scope.$on('ds:agent-after-validate', (e, result) => {
        if (result.valid) {
          applyChanges(result.edgeAgent);
        }
      });*/

      vm.validateGeneral = validateGeneral;
      vm.validateContent = validateContent;
      vm.selectParent = selectParent;
      vm.filterParents = filterParents;
      vm.addAssets = addAssets;
      vm.applyChanges = applyChanges;

      $timeout(() => {
        initModal();
      }, 100);

      $root.$on('ds:agent-generated-error', (e, error) => {
        vm.disableSave = !!error;
        console.log(error);
      });
    };

    function initModal() {
      vm.currentStep = { index: 0 };
      const wizard = WizardHandler.wizard();

      vm.enabledSteps = wizard.getEnabledSteps().length;
      vm.offStepChange = $scope.$on('wizard:stepChanged', function (event, args) {
        vm.showDiff = false;

        vm.currentStep = {
          index: args.index,
          name: args.step.wzData.step,
        };
      });
    }

    function validateGeneral() {
      return utils.Promise((resolve, reject) => {
        const offResponse = $root.$on('ds:agent-validate-after', (e, response) => {
          offResponse();
          resolve(response.valid);
        });
        $scope.$broadcast('ds:agent-validate');
      });
    }

    function validateAgentContent() {
      return utils.Promise((resolve, reject) => {
        const offResponse = $root.$on('ds:agent-validate-content-after', (e, response) => {
          offResponse();
          resolve(response);
        });
        $scope.$broadcast('ds:agent-validate-content');
      });
    }

    function validateContent() {
      return validateAgentContent().then((response) => response.valid);
    }

    function filterParents() {
      vm.selectedParent = null;
      vm.selectedAssets = [];
      const filteredParents = vm.assetsArray.filter(
        (current) => current.projectId === vm.projectId
      );
      const map = filteredParents.reduce((map, asset) => {
        map[asset.id] = map[asset.id] || { children: [] };
        map[asset.assetId] = map[asset.assetId] || { children: [] };

        map[asset.id].asset = asset;
        map[asset.assetId].children.push(asset);
        return map;
      }, {});

      vm.filteredParents = Object.values(map).reduce((array, current) => {
        if (current.asset && current.children.length) {
          array.push(current.asset);
        }
        return array;
      }, []);
    }

    function selectParent() {
      vm.selectedAssets = [];
      vm.filteredAssets = vm.assetsArray.filter(
        (current) => current.id === vm.selectedParent || current.assetId === vm.selectedParent
      );
    }

    function addAssets() {
      if (!vm.selectedAssets.length) {
        return;
      }

      vm.edgeAgent.assets = vm.edgeAgent.assets || [];

      let assets = vm.selectedAssets.map((current) => current.id);
      assets = assets.filter((current) => !vm.edgeAgent.assets.find((a) => a.id === current));

      if (assets.length) {
        vm.loadingAssets = true;
        Customer.prototype$__get__assets({
          id: vm.device.customerId,
          filter: {
            where: { id: { inq: assets } },
            fields: ['id', 'name', '_config', 'projectId', 'assetId'],
            include: {
              relation: 'asset',
              scope: { fields: ['id', 'name', '_config'] },
            },
          },
        })
          .$promise.then((assets) => {
            vm.loadingAssets = false;
            Array.prototype.push.apply(vm.edgeAgent.assets, assets);
          })
          .catch((err) => {
            vm.loadingAssets = false;
            console.log(err);
          });
      }
    }

    function applyChanges() {
      if (vm.disableSave) {
        return;
      }
      vm.loading = true;
      let toLink = [];
      let toUnlink = [];
      let edgeAgent;
      validateGeneral()
        .then((valid) => {
          if (!valid) {
            throw new Error('INVALID AGENT');
          }
          return validateAgentContent();
        })
        .then((result) => {
          if (!result.valid) {
            throw new Error('INVALID AGENT CONTENT');
          }

          const agent = EdgeAgentService.getAgentBody(result.edgeAgent);
          agent.name = vm.edgeAgent.name;
          agent.sharedPath = vm.edgeAgent.sharedPath;
          agent.image = vm.edgeAgent.image.name + ':' + vm.edgeAgent.image.version;
          agent.enabled = vm.edgeAgent.enabled;
          agent.templateTagId = vm.edgeAgent.templateTagId;

          if (!vm.edgeAgent.id) {
            return Customer.prototype$__create__devices__edgeAgents(
              {
                id: vm.device.customerId,
                nk: vm.device.id,
              },
              agent
            ).$promise;
          } else {
            return Customer.prototype$__updateById__devices__edgeAgents(
              {
                id: vm.device.customerId,
                nk: vm.device.id,
                fk: vm.edgeAgent.id,
              },
              agent
            ).$promise;
          }
        })
        .then((result) => {
          edgeAgent = result;
          const oldAssetIds = vm.edgeAgentAssets.map((current) => current.id);
          vm.edgeAgent.assets = vm.edgeAgent.assets || [];
          const newAssetsIds = vm.edgeAgent.assets.map((current) => current.id);

          toLink = newAssetsIds.filter((current) => !oldAssetIds.includes(current));
          toUnlink = oldAssetIds.filter((current) => !newAssetsIds.includes(current));

          return toggleEdgeAgentAssetsRel(edgeAgent.id, toLink, 'link');
        })
        .then(() => {
          return toggleEdgeAgentAssetsRel(edgeAgent.id, toUnlink, 'unlink');
        })
        .then(() => {
          return EdgeDeviceService.loadEdgeAgents(vm.device.customerId, vm.device.id);
        })
        .then(function (agents) {
          vm.loading = false;
          vm.modalInstance.close(agents);
        })
        .catch(function (err) {
          vm.loading = false;
          vm.saveError = utils.getHTTPError(err);
        });
    }

    function toggleEdgeAgentAssetsRel(edgeAgentId, assetIds, type) {
      type = utils.capitalize(type);
      if (!assetIds || !assetIds.length) {
        return utils.Promise.resolve();
      }

      const chunks = utils.arrayToChunks(assetIds, 50);
      const promises = chunks.map((chunk) => {
        return {
          function: EdgeAgent[`prototype$__bulk${type}__assets`],
          args: [
            {
              id: edgeAgentId,
              where: { id: { inq: chunk } },
            },
            {},
          ],
        };
      });
      return utils.inOrderPromises(promises);
    }
  }
})();
